<div class="kpd-selector">
  <!-- Selected KPD Code Display -->
  <div *ngIf="kpdCode" class="mb-2">
    <div class="flex items-center bg-primary text-white px-3 py-1 rounded text-sm max-w-full">
      <div class="mr-2 min-w-0 flex-1">
        <span class="font-mono font-semibold">{{ kpdCode }}</span>
        <span *ngIf="kpdName" class="ml-1">- {{ kpdName }}</span>
      </div>
      <button type="button"
              (click)="clearKpdCode()"
              class="hover:bg-primaryDark rounded-full w-4 h-4 flex items-center justify-center transition-colors flex-shrink-0">
        <i class="fas fa-times text-xs"></i>
      </button>
    </div>
  </div>

  <!-- KPD Code Search Field (only show if no code selected) -->
  <div *ngIf="!kpdCode" class="relative">
    <input type="text"
           #searchInput
           [formControl]="searchControl"
           [placeholder]="placeholder"
           [class.border-red]="isInvalid"
           [class.border-gray]="!isInvalid"
           class="w-full text-sm px-3 py-2 border rounded"
           style="font-size: 14px;">

    <!-- Loading Indicator -->
    <div *ngIf="isSearchingKpd" class="absolute right-3 top-3">
      <i class="fas fa-spinner fa-spin text-primary text-sm"></i>
    </div>
  </div>

  <!-- Search Results Dropdown (Fixed Positioning) -->
  <div *ngIf="kpdSearchResults && dropdownStyle"
       [ngStyle]="dropdownStyle"
       class="bg-white border border-gray rounded-md shadow-lg overflow-y-auto"
       style="max-height: 400px;">
    <!-- Suggested Codes (NKD-filtered) -->
    <div *ngIf="kpdSearchResults.suggested && kpdSearchResults.suggested.length > 0">
      <div class="px-3 py-2 bg-primaryWashed border-b border-gray">
        <p class="text-xs font-semibold text-grayDark">
          <i class="fas fa-star text-green mr-1"></i>
          <span i18n="KPD selector suggested codes header">Predlagano za vašo dejavnost</span>
        </p>
      </div>
      <button type="button"
              *ngFor="let kpd of kpdSearchResults.suggested"
              (click)="selectKpdCode(kpd.code, kpd.name)"
              class="w-full text-left px-3 py-2 hover:bg-grayWashed transition-colors border-b border-grayWashed last:border-b-0">
        <div class="font-mono font-semibold text-primary text-sm">{{ kpd.code }}</div>
        <div class="text-sm text-grayDark">{{ kpd.name }}</div>
      </button>
    </div>

    <!-- All Matching Codes (excluding suggested ones) -->
    <div *ngIf="hasNonSuggestedCodes()">
      <div class="px-3 py-2 border-b border-gray" style="background-color: #f5f5f5;">
        <p class="text-xs font-semibold text-grayDark">
          <i class="fas fa-list mr-1"></i>
          <span i18n="KPD selector all codes header">Vse KPD šifre</span>
        </p>
      </div>
      <ng-container *ngFor="let kpd of kpdSearchResults.all">
        <button type="button"
                *ngIf="!isKpdCodeSuggested(kpd.code)"
                (click)="selectKpdCode(kpd.code, kpd.name)"
                class="w-full text-left px-3 py-2 hover:bg-grayWashed transition-colors border-b border-grayWashed last:border-b-0">
          <div class="font-mono font-semibold text-primary text-sm">{{ kpd.code }}</div>
          <div class="text-sm text-grayDark">{{ kpd.name }}</div>
        </button>
      </ng-container>
    </div>

    <!-- No Results -->
    <div *ngIf="(!kpdSearchResults.suggested || kpdSearchResults.suggested.length === 0) && (!kpdSearchResults.all || kpdSearchResults.all.length === 0)"
         class="px-3 py-2 text-sm text-grayDark">
      <span i18n="KPD selector no results">Ni rezultatov</span>
    </div>
  </div>

  <p class="text-xs text-grayDark mt-1" *ngIf="!kpdCode">
    {{ hint }}
  </p>
</div>
